import { render, staticRenderFns } from "./CouponSure.vue?vue&type=template&id=35f28640&scoped=true&"
import script from "./CouponSure.vue?vue&type=script&lang=ts&"
export * from "./CouponSure.vue?vue&type=script&lang=ts&"
import style0 from "./CouponSure.vue?vue&type=style&index=0&id=35f28640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f28640",
  null
  
)

export default component.exports